import { format as dateFnsFormat, parse, subMonths } from "date-fns";
import { fr } from "date-fns/locale";

export const format = (date: Date, formatString: string) => {
  return dateFnsFormat(date, formatString, { locale: fr });
  //   return formattedDate.replace(/(\b[a-z])/, (match) => match.toUpperCase());
};

export const getDate = (date: Date) => {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0")
  );
};

export const parseDate = (date: string, formatStr = "dd/MM/yy") => {
  const parsedDate = parse(date, formatStr, new Date(), { locale: fr });

  return parsedDate;
};

export const getLast6MonthsStartAndEndDates = () => {
  const today = new Date();
  const sixMonthsAgo = subMonths(today, 6);
  // const startOf6MonthsAgo = startOfMonth(
  //   new Date(today.setMonth(today.getMonth() - 6)),
  // );
  const endOfCurrentMonth = new Date();

  return {
    start: sixMonthsAgo,
    end: endOfCurrentMonth,
  };
};
